module.exports = __webpack_public_path__ + "img/file_modal.3094317b.svg";